import React from "react";

import fbLogo from "./fb-logo-white.png";
export default class SignInFacebook extends React.Component {
  //   componentWillMount() {
  //     auth.onAuthStateChanged().then(user => {
  //       if (user) {
  //         this.setState({ user });
  //       }
  //     });
  //   }

  render() {
    //const { user } = this.state;
    return (
      <div>
        {/*<p>{user ? `Hi, ${user.displayName}!` : "Hi!"}</p>*/}
        <button className="fb-button" onClick={this.props.login}>
          <div>
            <img height="20px" src={fbLogo} alt="" />
            <div> &nbsp; Sign in with Facebook</div>
          </div>
        </button>
      </div>
    );
  }
}
